/** Shared by the hosted client and its HTML connection hint. */
export const DEFAULT_ACCOUNT_API_BASE = "https://api.ato.run";

export function normalizeAccountApiBase(configured: string): string {
  return configured.replace(/\/$/, "");
}
